import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ModalType } from '@challenger6/vm-pattern-library/modal';
import { SupportOptionsAdapter } from './adapters/support-options-adapter.model';
import { SupportOptionType } from './enums/support-options-type.enum';
import { SupportOption } from './models/try-something-else-model';
import { LibConfig } from '../../models/lib-config.model';
import { LIB_CONFIG } from '../../../lib/lib-config';
import { ButtonLevel, ButtonStyle } from '@challenger6/vm-pattern-library/button';

@Component({
  selector: 'vm-try-something-else',
  templateUrl: './try-something-else.component.html',
  styleUrls: ['./try-something-else.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TrySomethingElseComponent implements OnInit {
  @Input() supportOptions: any;
  @Input() liveChatTagId: string;

  @Output() supportOptionSelected = new EventEmitter<SupportOption>();

  ButtonStyle = ButtonStyle;
  ButtonLevel = ButtonLevel;

  showModal = false;
  selectedTile: SupportOption;
  strapiURL: string;
  modalType = ModalType.Standard;
  supportOptionType = SupportOptionType;
  formattedSupportOptions: SupportOption[];
  accessibilitySupportLink: SupportOption;

  constructor(private supportOptionsAdapter: SupportOptionsAdapter, @Inject(LIB_CONFIG) private config: LibConfig) {}

  ngOnInit(): void {
    this.strapiURL = this.config.strapiURL;
    if (this.supportOptions?.support_options) {
      this.formattedSupportOptions = this.supportOptionsAdapter
        .adapt(this.supportOptions.support_options)
        .sort((a, b) => a.displayOrder - b.displayOrder);

      this.accessibilitySupportLink = this.formattedSupportOptions[2];
      this.formattedSupportOptions.length = 2;
    }
  }

  onTileClick(supportTile: SupportOption) {
    this.supportOptionSelected.emit(supportTile);
    this.selectedTile = supportTile;

    if (supportTile.type === SupportOptionType.Modal) {
      this.showModal = true;
    }

    if (supportTile.type === SupportOptionType.LiveChat) {
      return false;
    }
  }
}
